import { QueryParametersAppState } from './getAppStateFromQueryParameters'

export const getGtmQueryParamDataFromAppQueryState = (
    appState?: QueryParametersAppState
) => ({
    app_id: appState?.appId,
    gclid: appState?.googleClickId,
    msclkid: appState?.msclkId,
    utm_message_id: appState?.utmMessageId,
    utm_source: appState?.utmSource,
    utm_medium: appState?.utmMedium,
    utm_campaign: appState?.utmCampaign,
    utm_content: appState?.utmContent,
})
